import { ElementType, Suspense, lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import AuthGuard from 'components/AuthGuard';
import DashboardLayout from 'src/pages/shared/DashboardLayout';
import LoadingScreen from 'components/LoadingScreen';
import RequireAuth from 'components/RequireAuth ';
import { LoginType } from 'src/types/loginData';
import ErrorBoundary from 'src/pages/ErrorBoundary';
import LoginInspector from 'src/pages/authentication/LoginInspector';
import LoginMailInspector from 'src/pages/authentication/LoginMailInspector';
import GuestGuard from 'src/components/GuestGuard';

// eslint-disable-next-line react/display-name, @typescript-eslint/no-explicit-any
const Loadable = (Component: ElementType) => (props: any) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <ErrorBoundary>
        <Component {...props} />
      </ErrorBoundary>
    </Suspense>
  );
// Home
const Home = Loadable(lazy(() => import('./pages/dashboard/HomePage')));
// Authentication pages

// const Login = Loadable(lazy(() => import('./pages/authentication/Login')));
// const LoginInspector = Loadable(
//   lazy(() => import('./pages/authentication/LoginInspector'))
// );

const UserProfile = Loadable(
  lazy(() => import('./pages/driverDocument/UserProfilePage'))
);

// Deal pages

const HHEEDealPage = Loadable(lazy(() => import('./pages/deals/DealPage')));
const DealDriverPage = Loadable(
  lazy(() => import('./pages/deals/DealDriverPage'))
);

// Report pages
const Attendance = Loadable(
  lazy(() => import('./pages/attendance/AttendancePage'))
);
const DailyAttendance = Loadable(
  lazy(() => import('./pages/dailyAttendance/DailyAttendancePage'))
);

const SundaysAndHolidays = Loadable(
  lazy(() => import('./pages/sundaysAndHolidays/SundaysAndHolidaysPage'))
);

const ModifiedProgramming = Loadable(
  lazy(() => import('./pages/programming/ModifiedProgrammingPage'))
);
const Programming = Loadable(
  lazy(() => import('./pages/programming/ProgrammingPage'))
);
const RouteSheet = Loadable(
  lazy(() => import('./pages/routeSheet/RouteSheetPage'))
);

const CommentShiftAttendance = Loadable(
  lazy(() => import('./pages/routeSheet/CommentShiftAttendancePage'))
);

const DriverSummary = Loadable(
  lazy(() => import('./pages/attendanceSummary/AttendanceSummaryPage'))
);

const IncidentReport = Loadable(
  lazy(() => import('./pages/incidentReport/IncidentReportPage'))
);

// SearchAttendance Page
const SearchPunche = Loadable(
  lazy(() => import('./pages/search/SearchPunchPage'))
);

// DriversMailConfig Page
const DriversMailConfigPage = Loadable(
  lazy(() => import('./pages/driversMailConfig/DriversMailConfigPage'))
);

// UserAccount Page
const UserAccount = Loadable(
  lazy(() => import('./pages/userAccount/UserAccountPage'))
);

// Profiles Page
const ProfilesPage = Loadable(
  lazy(() => import('./pages/profiles/ProfilesPage'))
);

const DailyControl = Loadable(
  lazy(() => import('./pages/dailyControl/DailyControlPage'))
);

// Inspector selection Page
const InspectorAccess = Loadable(
  lazy(() => import('./pages/inspectorAccess/InspectorAccessPage'))
);

const GeneralRequest = Loadable(
  lazy(() => import('./pages/generalRequest/GeneralRequestPage'))
);

// ScheduleLoad Page
const ScheduleLoad = Loadable(
  lazy(() => import('./pages/scheduleLoad/ScheduleLoadPage'))
);

const ModifiedPunches = Loadable(
  lazy(() => import('./pages/driverPunches/ModifiedPunchesPage'))
);

// DriverDocument pages
const DriverDocument = Loadable(
  lazy(() => import('./pages/driverDocument/DriverDocumentPage'))
);

// Error pages

const AuthorizationRequired = Loadable(
  lazy(() => import('./pages/AuthorizationRequired'))
);
const NotFound = Loadable(lazy(() => import('./pages/NotFound')));
const ServerError = Loadable(lazy(() => import('./pages/ServerError')));

const routes: RouteObject[] = [
  {
    path: 'loginInspector',
    element: <LoginInspector />,
  },
  {
    path: 'loginMailInspector',
    element: (
      <GuestGuard type={LoginType.INSPECTOR}>
        <LoginMailInspector />
      </GuestGuard>
    ),
  },
  {
    path: 'inspectorDT',
    element: (
      <AuthGuard type={LoginType.INSPECTOR}>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '/inspectorDT',
        element: (
          <RequireAuth systemModules="InspectorAccess">
            <InspectorAccess />
          </RequireAuth>
        ),
      },
    ],
  },
  {
    path: '/',
    element: (
      <AuthGuard type={LoginType.NORMAL}>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: 'perfilUsuario',
        element: <UserProfile />,
      },
      {
        path: 'manejo_de_usuarios',
        children: [
          {
            path: 'usuarios',
            element: (
              <RequireAuth systemModules="ManejodeUsuarios">
                <UserAccount />
              </RequireAuth>
            ),
          },
          {
            path: 'perfiles',
            element: (
              <RequireAuth systemModules="ManejodeUsuariosPerfiles">
                <ProfilesPage />
              </RequireAuth>
            ),
          },
          {
            path: 'documentos',
            element: (
              <RequireAuth systemModules="DocumentosTrabajador">
                <DriverDocument />
              </RequireAuth>
            ),
          },
        ],
      },
      {
        path: 'configuracion_correos',
        element: (
          <RequireAuth systemModules="ConfiguracionCorreos">
            <DriversMailConfigPage />
          </RequireAuth>
        ),
      },
      {
        path: 'busqueda_de_asistencia',
        element: (
          <RequireAuth systemModules="BuscarAsistencia">
            <SearchPunche />
          </RequireAuth>
        ),
      },
      {
        path: 'anexos',
        children: [
          {
            path: 'programacion',
            element: (
              <RequireAuth systemModules="Programacion">
                <Programming />
              </RequireAuth>
            ),
          },
          {
            path: 'planilla_de_ruta',
            element: (
              <RequireAuth systemModules="PlanilladeRuta">
                <RouteSheet />
              </RequireAuth>
            ),
          },
          {
            path: 'observaciones_planilla_de_ruta',
            element: (
              <RequireAuth systemModules="ObservacionesPlanilladeRuta">
                <CommentShiftAttendance />,
              </RequireAuth>
            ),
          },
          {
            path: 'resumen_trabajado',
            element: (
              <RequireAuth systemModules="ResumenTrabajado">
                <DriverSummary />
              </RequireAuth>
            ),
          },
        ],
      },
      {
        path: 'reportes',
        children: [
          {
            path: 'asistencia',
            element: (
              <RequireAuth systemModules="Asistencia">
                <Attendance />
              </RequireAuth>
            ),
          },
          {
            path: 'jornada_diaria',
            element: (
              <RequireAuth systemModules="JornadaDiaria">
                <DailyAttendance />
              </RequireAuth>
            ),
          },
          {
            path: 'domingos_y_festivos',
            element: (
              <RequireAuth systemModules="DomingosFestivos">
                <SundaysAndHolidays />
              </RequireAuth>
            ),
          },
          {
            path: 'modificacion_programacion',
            element: (
              <RequireAuth systemModules="ModificacionProgramacion">
                <ModifiedProgramming />
              </RequireAuth>
            ),
          },
          {
            path: 'incidentes',
            element: (
              <RequireAuth systemModules="Incidentes">
                <IncidentReport />
              </RequireAuth>
            ),
          },
          {
            path: 'control_diario',
            element: (
              <RequireAuth systemModules="ControlDiario">
                <DailyControl />
              </RequireAuth>
            ),
          },
        ],
      },
      {
        path: 'pactos',
        children: [
          {
            path: 'pacto_hhee',
            element: (
              <RequireAuth systemModules="PactosHHEE">
                <HHEEDealPage />
              </RequireAuth>
            ),
          },
          {
            path: 'conductor/:id',
            element: (
              <RequireAuth systemModules="MisPactos">
                <DealDriverPage />
              </RequireAuth>
            ),
          },
        ],
      },
      {
        path: 'servicios',
        children: [
          {
            path: 'control_diario',
            element: (
              <RequireAuth systemModules="ControlDiario">
                <DailyControl />
              </RequireAuth>
            ),
          },
        ],
      },
      {
        path: 'solicitudes_generales',
        element: <GeneralRequest />,
      },
      {
        path: 'carga_de_programacion',
        element: (
          <RequireAuth systemModules="CargaProgramacion">
            <ScheduleLoad />
          </RequireAuth>
        ),
      },
      {
        path: 'marcas_manuales',
        element: (
          <RequireAuth systemModules="MarcasModificadas">
            <ModifiedPunches />
          </RequireAuth>
        ),
      },
    ],
  },
  {
    path: '*',
    element: (
      <AuthGuard type={LoginType.NORMAL}>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '401',
        element: <AuthorizationRequired />,
      },
      {
        path: '404',
        element: <NotFound />,
      },
      {
        path: '500',
        element: <ServerError />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];

export default routes;
